{
  "seed": 1043130,
  "scenario": "mixed",
  "generatedAt": "2026-07-17T06:00:00.000Z"
}
